
<div class="instructions-container">
    <div class="instructions-header">
        <mat-icon>description</mat-icon>
        <h2>Sales Consultant Listing Form</h2>
    </div>
    
    <p class="intro-text">Welcome to the Sales Consultant Listing portal. Please follow these steps to ensure your document is processed correctly:</p>

    <div class="steps-grid">
        <div class="step-item">
            <div class="step-icon">
                <mat-icon>visibility</mat-icon>
                <div class="step-number">1</div>
            </div>
            <div class="step-content">
                <h3>Preview and Verify</h3>
                <p>On the <strong>left side</strong> of your screen, you will see a live preview of the official PDF. Reference this to ensure your information matches the document sections.</p>
            </div>
        </div>

        <div class="step-item">
            <div class="step-icon">
                <mat-icon>edit_note</mat-icon>
                <div class="step-number">2</div>
            </div>
            <div class="step-content">
                <h3>Fill Out the Form</h3>
                <p>On the <strong>right side</strong>, enter the required details:</p>
                <ul>
                    <li><strong>Address:</strong> Match the legal records shown in the preview.</li>
                    <li><strong>Signature:</strong> Use the pad to provide authorization.</li>
                    <li><strong>ID:</strong> Verify your Consultant ID before proceeding.</li>
                </ul>
            </div>
        </div>

        <div class="step-item">
            <div class="step-icon">
                <mat-icon>settings_suggest</mat-icon>
                <div class="step-number">3</div>
            </div>
            <div class="step-content">
                <h3>Submission & Generation</h3>
                <p>Upon clicking <strong>Submit</strong>, the system maps your responses to the PDF. A <strong>download link</strong> will be generated immediately for your records.</p>
            </div>
        </div>

        <div class="step-item">
            <div class="step-icon">
                <mat-icon>verified_user</mat-icon>
                <div class="step-number">4</div>
            </div>
            <div class="step-content">
                <h3>Review & Approval</h3>
                <p>Your form will enter our review queue. Once finalized, you will receive an <strong>email notification</strong> confirming your approval status.</p>
            </div>
        </div>
    </div>

    <!-- <p><mat-icon>info</mat-icon> If you prefer to print the form to fill out, you can do so by downloading the form. The completed form can be sent to <a href="mailto:sales@horizinns.com">sales@horizinns.com</a></p>

    <button mat-button (click)="downloadForm()">
        <mat-icon>file_download</mat-icon> Download Form
    </button> -->

</div>